<template>
  <div class="grid">
    <div class="element">
      <div style="text-align: center" class="title-box">
        <span style="padding-top:2px" class="dot">{{number}}</span>
        <span class="title ml-2">{{title}}</span>
      </div>
      <div class="item text-center">
        <div class="grid img">
          <i class="text-center icon icon-bor-book" />
          <span>該当画面キャプチャ<br>画面確定後、差し込み</span>
        </div>
      </div>
    </div>
    <div class="mt-2 description" v-html="description">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: ['number', 'title', 'description'],
  components: {
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>